import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {rbacActions} from "../../config/rbac/actions.ts";
import {AddPage as AddAccountApplicationPage} from "../account-applications/pages/AddPage.tsx";

export const AccountsLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListAccounts} redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action={rbacActions.CreateAccount} redirectTo='/accounts'>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetAccount} redirectTo='/accounts'>
                        <EditPage/>
                    </RequirePermission>
                }
            />

            <Route
                path=':id/applications/add'
                element={
                    <RequirePermission action={rbacActions.CreateAccountApplication} redirectTo='/accounts'>
                        <AddAccountApplicationPage/>
                    </RequirePermission>
                }
            />

        </Routes>
    );
};
